import {
  REQUEST_AGREEMENTS,
  REQUEST_AGREEMENTS_SUCCESS,
  REQUEST_AGREEMENTS_FAILURE,
  REQUEST_AGREEMENT_YES,
  REQUEST_AGREEMENT_NO,
  UPDATE_AGREEMENT_ANSWERS,
} from 'constants/ActionTypes';

const initState = {
  agreementsByID: {},
  hasError: false,
  agreementsLoading: false,
  agreementsError: null,
};

export default function AgreementsReducer(state = initState, action) {
  switch (action.type) {
    case UPDATE_AGREEMENT_ANSWERS: {
      const newAgreementsByID = state.agreementsByID;
      const newAnswer = action.newAnswer;
      newAgreementsByID[newAnswer.EmployeeDetailID].answers[newAnswer.AgreementID] = newAnswer;
      return {
        ...state,
        agreementsByID: newAgreementsByID,
      };
    }
    case REQUEST_AGREEMENTS:
      return {
        ...state,
        hasError: false,
        agreementsError: null,
        agreementsLoading: true,
        agreementsByID: {},
      };
    case REQUEST_AGREEMENTS_SUCCESS:
      return {
        ...state,
        agreementsByID: {
          ...state.agreementsByID,
          ...action.newAgreements,
        },
        agreementsLoading: false,
      };
    case REQUEST_AGREEMENTS_FAILURE:
      return {
        ...state,
        hasError: true,
        agreementsError: action.error,
        agreementsLoading: false,
      };
    case REQUEST_AGREEMENT_YES:
      return {
        ...state,
      };
    case REQUEST_AGREEMENT_NO:
      return {
        ...state,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/AgreementsReducer.js